<template>
  <div class="toolsBox">
    <div class="web__tools">
      <dl v-if="showEmoji()" class="xxxx">
        <el-popover
          placement="top-start"
          trigger="click"
          ref="popover"
          :disabled="!config.canOperate || feedback"
        >
          <div class="emjioBox">
            <ul class="emjio">
              <li
                v-for="item in Object.keys(emoji)"
                :key="item"
                @click="selectEmit(item)"
              >
                <a
                  v-if="emoji[item] && emoji[item].position"
                  :style="emojiStyle(item)"
                ></a>
                <a v-else-if="emoji[item].length < 5">{{ emoji[item] }}</a>
                <img v-else :src="emoji[item]" />
              </li>
            </ul>
          </div>
          <div class="btn_div01" slot="reference" style="margin-right: 0.5rem">
            <img class="btn_icon" src="../../../static/talks/t_smile.png" />
            <div class="btn_title">表情</div>
          </div>

          <!-- <JwChat-icon slot="reference" type="icon-xiaolian" title="表情" /> -->
        </el-popover>
      </dl>

      <!-- <template v-for="(item,k) in showkeys()">
				<span v-if="toolConfig[item]" :key="item" :style="item=='history'&&'flex-grow: 100;text-align: right;'">
					<span @click="bindButton(item)">
						<JwChat-icon :type="toolConfig[item].icon" :title="setTitle(item,k)" />
					</span>
				</span>
				<i :key="item" v-else :class="item" @click="bindButton(item)"></i>
			</template> -->

      <!-- <div class="sendimg">
        <div class="file_div"></div>

        <input
          id="upvideo"
          class="file_input"
          type="file"
          accept="video/mp4,video/webm,video/ogg"
          ref="inputerVideo"
          @change="videoUpload"
        />
        <div class="btn_title">选择视频</div>
      </div> -->
      
      <div class="sendimg">
        <div class="file_div"></div>

        <input
          id="upfile"
          class="file_input"
          type="file"
          accept="image/png,image/jpeg,image/gif,image/jpg"
          ref="inputer"
          @change="fileUpload"
          :disabled="!config.canOperate || feedback"
        />
        <div class="btn_title">选择图片</div>
      </div>
      <div
        class="btn_div03"
        style="min-width: 60px; margin-left: 0.5rem"
        v-if="config.canOperate || this.$store.state.selectedKey === 3"
        @click="copyText"
      >
        <img class="btn_icon" src="../../../static/talks/t_alltextcopy.png" />
        <input
          type="button"
          class="btn_title"
          value="复制全文"
          style="border: none; background: transparent; cursor: pointer"
        />
      </div>
      <div
        class="btn_div03"
        style="min-width: 60px; margin-left: 0.5rem"
        v-else
      >
        <img class="btn_icon" src="../../../static/talks/t_alltextcopy.png" />
        <input
          type="button"
          class="btn_title"
          value="复制全文"
          style="border: none; background: transparent; cursor: pointer"
        />
      </div>
      <div
        class="btn_div04"
        style="min-width: 60px; margin-left: 0.5rem"
        v-if="
          config.canOperate || this.$store.state.selectedKey === 3 || feedback
        "
        @click="showPopupSetHight"
      >
        <img
          class="btn_icon"
          style="height: 1.125rem"
          src="../../../static/talks/t_setheight.png"
        />
        <input
          type="button"
          class="btn_title"
          value="设置高度"
          style="border: none; background: transparent; cursor: pointer"
        />
      </div>
      <div class="icon_box">
        <div
          class="btn_div"
          v-if="$store.state.toLastKeyName == '对话中'"
          v-show="$store.state.authority.isTransfer"
          @click="interpretAction(0)"
        >
          <img class="btn_icon" src="../../../static/talks/t_interpret.png" />
          <div class="btn_title">转接</div>
        </div>
        <div
          class="btn_div3"
          v-if="$store.state.toLastKeyName === '我的同事'"
          v-show="$store.state.authority.isTransferTa"
          @click="adapterAction(4)"
        >
          <img class="btn_icon" src="../../../static/talks/t_adapter.png" />
          <div class="btn_title">转接Ta</div>
        </div>
        <div
          v-if="
            ($store.state.toLastKeyName == '对话中' ||
              $store.state.toLastKeyName == '疑似骚扰用户') &&
            !$store.state.colleageAngle
          "
          v-show="$store.state.authority.isDisturb"
        >
          <div class="btn_div1" @click="disturbAction(2)">
            <img class="btn_icon" src="../../../static/talks/t_disturb.png" />
            <div class="btn_title">{{ isDisturb ? "取消勿扰" : "勿扰" }}</div>
          </div>
          <!-- <div class="btn_div1_select" @click="disturbAction(2)">
            <img
              class="btn_icon"
              src="../../../static/talks/t_disturbselect.png"
            />
            <div class="btn_title_select">取消勿扰</div>
          </div> -->
        </div>

        <!-- <div
          v-if="$store.state.toLastKeyName == '对话中'"
          v-show="$store.state.authority.isDefriend"
        >
          <div class="btn_div2" v-if="!isDefriend" @click="defriendAction(3)">
            <img class="btn_icon" src="../../../static/talks/t_defriend.png" />
            <div class="btn_title">拉黑</div>
          </div>
          <div class="btn_div2_select" v-else @click="defriendAction(3)">
            <img
              class="btn_icon"
              src="../../../static/talks/t_defriendselect.png"
            />
            <div class="btn_title_select">拉黑</div>
          </div>
        </div> -->

        <div
          v-if="$store.state.toLastKeyName == '对话中' && config.source == '7'"
        >
          <div class="btn_div2" v-if="!isDefriend" @click="sendCard()">
            <img class="btn_icon" src="../../../static/talks/t_defriend.png" />
            <div class="btn_title">留资卡</div>
          </div>
          <div class="btn_div2_select" v-else @click="sendCard()">
            <img
              class="btn_icon"
              src="../../../static/talks/t_defriendselect.png"
            />
            <div class="btn_title_select">留资卡</div>
          </div>
        </div>

        <!-- <div
        >
          <div class="btn_div2" @click="curTalkAction()">
            <img class="btn_icon" src="../../../static/talks/t_defriend.png" />
            <div class="btn_title">当前会话</div>
          </div>
      
        </div> -->

        <div
          class="end_div"
          v-if="
            ($store.state.toLastKeyName == '对话中' ||
              $store.state.toLastKeyName == '我的同事') &&
            !$store.state.colleageAngle
          "
          @click="endAction(1)"
          v-show="$store.state.authority.isEndChat"
        >
          <img class="btn_icon" src="../../../static/talks/t_end.png" />
          <div class="btn_title">结束对话</div>
        </div>

        
      </div>
      <!-- <el-button
        class="sendBtn"
        type="primary"
        size="mini"
        @click="sendAction"
        :disabled="config.canOperate == false"
        >发送</el-button
      > -->

      <el-dialog
        title="设置输入框高度"
        :visible.sync="popupHeightShow"
        width="30%"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
      >
        <el-radio-group v-model="radio">
          <el-radio label="130">默认</el-radio>
          <el-radio label="160">中</el-radio>
          <el-radio label="190">高</el-radio>
          <el-radio label="260">超高</el-radio>
        </el-radio-group>
        <span slot="footer" class="dialog-footer">
          <el-button @click="popupHeightShow = false">取 消</el-button>
          <el-button type="primary" @click="setHeight">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="留资卡" :visible.sync="dialogTableVisible"  width="30%">
        <el-table :data="cardList" style="width: 100%; height: 400px; overflow-y: auto; display: block;">
          <el-table-column property="name" label="标题" width="350"></el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button
                  type="text"
                  size="small"
                  @click="handleSend(scope.row)"
                  class="item_font"
                  >发送</el-button
                >
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <slot name="tools" />
    </div>
  </div>
</template>

<script>
import emoji from "@/utils/emoji";
export default {
  name: "JwChat-tools",
  props: {
    user: {},
    tools: {
      type: Object,
      default: () => {
        return {
          show: [],
          showEmoji: true,
          callback: () => {},
        };
      },
    },
    config: {
      type: Object,
      default: () => ({
        name: "",
        ipdress: "",
        number: "4",
        tags: [],
        source:"0",
        mark: "",
        itype: "0", //0-聊天界面引用  1-历史消息界面引用
        canOperate: Boolean, //界面元素是否可操作，false为不可，true为可以
      }),
      required: true,
    },
    list: {
      type: Array,
      default: () => [],
    },
    feedback: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      emoji,
      toolConfig: {
        img: {
          icon: "icon-xiangce",
          title: "图片",
        },
        // 'file': { icon: 'icon-wenjian', title: '文件' },
        // 'video': { icon: 'icon-shipin', title: '视频' },
        // 'hongbao': { icon: 'icon-translate', title: '翻译' },
        // 'more': { icon: 'icon-gengduo', title: '更多' },
        // 'history': { icon: 'icon-lishi', title: '历史' },
      },
      newTitle: null,
      isDefriend: false,
      isDisturb: false,
      userInfo: {},
      isTranster: false,
      isSwitch: false,
      allText: "",
      popupHeightShow: false,
      cardList: [],
      dialogTableVisible:false,
      radio: JSON.parse(localStorage.getItem("inputHeight"))
        ? JSON.parse(localStorage.getItem("inputHeight"))
        : "130",
    };
  },
  methods: {
    // allTextCopy(e) {
    //   this.$store.state.allText = e.allText;
    //   console.log("复制成功");
    // },
    onError() {
      console.log("复制出错");
    },
    // 高度
    showPopupSetHight() {
      this.popupHeightShow = true;
    },
    // 设置高度
    setHeight() {
      const height = this.radio;
      this.$store.state.inputHeight = height + "px";
      console.log(
        "this.$store.state.inputHeight:",
        this.$store.state.inputHeight
      );

      // 兼容客户端
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf("electron/") > -1) {
        console.log("tools.vue  setHegiht:electron环境");
        const fs = this.$nodeFs;
        const options = {
          siteObj: JSON.parse(localStorage.getItem("siteObj")),
          username: JSON.parse(localStorage.getItem("username")),
          station: this.util.getLocalSite().webId,
          stations: JSON.parse(localStorage.getItem("stations")),
          stationsAndNames: JSON.parse(
            localStorage.getItem("stationsAndNames")
          ),
          inputHeight: height,
        };
        try {
          fs.writeFileSync(this.userDirectory, JSON.stringify(options));
        } catch (error) {
          console.log("tools.vue setHeight 写入文件 失败原因", error);
        }
        // fs.writeFile(
        //   this.userDirectory,
        //   JSON.stringify(options),
        //   function (err) {
        //     if (err) {
        //       console.log("tools.vue  写入文件 失败" + err);
        //       return;
        //     }
        //     console.log("tools.vue 写入文件 It's saved!");
        //   }
        // );
      }
      localStorage.setItem("inputHeight", JSON.stringify(height));
      this.popupHeightShow = false;
    },
    // 获取用户信息
    async getDetailRequest() {
      console.log("复制成功");
      // if (this.config.canOperate === false) {
      //   return;
      // }
      const isColleague = this.$store.state.colleageAngle;
      let selected;
      if (!isColleague) {
        selected = this.$store.state.selectedClient;
      } else {
        selected = this.$store.state.college.nowSelectClient;
      }
      var api = "/manager/chat/customer/detail";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          cid: selected.cid,
          csid: this.util.getLocalId(),
          sid: selected.sid,
        },
      });
      this.initAlltext(response.data);
      this.$store.state.allText = this.allText;
      console.log("-----------------text", this.allText);
      this.$store.state.copyText = this.allText;
      this.$message.success("复制成功");
      this.$copyText(this.allText).then(
        function (e) {
          console.log(e);
        },
        function (e) {
          console.log(e);
        }
      );
      // this.$message.success("复制成功");
    },
    initAlltext(userData) {
      this.allText = "";
      // this.allText = "昵称:" + userData.customerNickname
      let nickname =
        userData.customerNickname != null ? userData.customerNickname : "";
      let cid = userData.cid;
      let remark =
        userData.customerRemark != null ? userData.customerRemark : "";
      let keyword = userData.keyword ? userData.keyword : "无";
      let searchword = userData.query ? userData.query : "无";
      let source = userData.source == 1 ? "百度" : "";
      let labels = this.getLabels(userData.lastLabels);
      this.allText =
        "昵称:" +
        nickname +
        "\n" +
        "永久编号:" +
        cid +
        "\n" +
        "备注:" +
        remark +
        "\n" +
        "搜索词：" +
        searchword +
        "\n" +
        "关键词:" +
        keyword +
        "\n" +
        "来源:" +
        source +
        "\n" +
        "标签:" +
        labels +
        "\n";
      // console.log("chatList initAlltext ",this.allText)
      if (this.list != null) {
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].name != "") {
            this.allText =
              this.allText +
              this.list[i].name +
              " " +
              this.list[i].date +
              " " +
              this.list[i].text.text +
              "\n";
          } else {
            this.allText =
              this.allText +
              this.list[i].date +
              " " +
              this.list[i].text.text +
              "\n";
          }
        }
      }
    },
    getLabels(list) {
      let labels = "";
      if (list != []) {
        for (let i = 0; i < list.length; i++) {
          labels = labels != "" ? labels + " " + list[i].name : list[i].name;
        }
      } else {
        labels = "";
      }
      return labels;
    },

    async cancelDisturbRequest() {
      const selected = this.$store.state.selectedClient;
      const account = this.util.getLocalAccount();
      var api = "/manager/session/del";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          userId: account.id,
          customerId: selected.cid,
          sid: selected.sid,
        },
      });
      console.log("bottomTools cancelDisturbRequest response = ", response);
      if (response.resultCode === "10000") {
        if (this.isDisturb) {
          //取消勿扰
          this.$store.commit("spliceTroubleObj", selected);
          const type = response.data;
          if (type === 1) {
            this.$store.commit("addTalkObj", selected);
          } else if (type === 2) {
            this.$store.commit("addBrowerObj", selected);
          } else if (type === 3) {
            this.$store.commit("addLeaveObj", selected);
          } else if (type === 4) {
            this.$store.commit("addTalkedObj", selected);
          }
          this.isDisturb = !this.isDisturb;
          this.$store.state.selectedClient = null;
        }
      } else {
        this.$message.error(response.desc);
      }
    },
    async setDisturbRequest() {
      const selected = this.$store.state.selectedClient;
      const account = this.util.getLocalAccount();

      var api = "/manager/session/addOrEdit";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          userId: account.id,
          customerId: selected.cid,
          sid: selected.sid,
        },
      });
      console.log("tools setDisturbRequest response = ", response);
      console.log(
        "this.$store.state.selectedKey = ",
        this.$store.state.selectedKey
      );
      if (response.resultCode === "10000") {
        this.isDisturb = !this.isDisturb;
        if (this.isDisturb === true) {
          //设置勿扰
          if (this.$store.state.selectedKey === 1) {
            this.$store.commit("spliceTalkObj", selected);
          } else if (this.$store.state.selectedKey === 2) {
            this.$store.commit("spliceBrowerObj", selected);
          } else if (this.$store.state.selectedKey === 3) {
            this.$store.commit("spliceLeaveObj", selected);
          }
          this.$store.commit("addTroubleObj", selected);
          this.$store.state.selectedClient = null;
        }
      } else {
        this.$message({
          type: "error",
          message: response.desc,
        });
      }
    },
    disturbAction(index) {
      console.log("bottomTools disturbAction index = ", index);

      if (this.isDisturb === false) {
        this.$confirm(
          "你确认要设置勿扰操作吗？",
          "设置为勿扰模式后，针对该用户，系统将接收不到新消息提醒，会话保留",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            showClose: false,
          }
        )
          .then(() => {
            this.setDisturbRequest();
          })
          .catch(() => {});
      } else {
        this.$confirm(
          "你确认要取消勿扰设置吗？",
          "取消勿扰设置后，将继续收到此用户发送的消息提醒",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            showClose: false,
          }
        )
          .then(() => {
            this.cancelDisturbRequest();
          })
          .catch(() => {});
      }
    },
    endAction(index) {
      console.log("bottomTools endAction index = ", index);
      console.log("bottomTools endAction userInfo = ", this.userInfo);

      this.$confirm(
        "你确认要设置结束对话吗？",
        "确认结束后将不再收到访客发送的消息",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          showClose: false,
        }
      )
        .then(() => {
          this.$emit("endChat", true);
        })
        .catch(() => {});
    },
    adapterAction(index) {
      console.log("bottomTools adapterAction index = ", index);
      this.isTranster = true;
      this.$emit("interpretAction", false);
    },
    async setBlackRequest() {
      const selected = this.$store.state.selectedClient;
      var api = "/manager/blacklist/add";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          conversationId: selected.sid,
          blackUserId: selected.cid,
          blackUserName: selected.nickname,
        },
      });
      console.log("index setBlackRequest response = ", response);
      if (response.resultCode === "10000") {
        this.isDefriend = true;
      }

      this.$store.dispatch("removeFromTalk", selected);
      this.$store.state.selectedClient = null;
    },

    async sendCard() {
      ///manager/bagelYunKuaishou/getMarketToolList
      const site = JSON.parse(localStorage.getItem("siteObj"));
      var api = "/manager/bagelYunKuaishou/getMarketToolList";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          webId: site.webId,
          retry: true
        },
      });
      console.log("index setBlackRequest response = ", response);
      if (response.resultCode === "10000") {
          console.log(response)
          this.dialogTableVisible = true
          this.cardList = response.data;
      }
    },

    handleSend(row) {
      this.dialogTableVisible = false
      console.log(row)
      //this.$emit("upImage", file);
      this.$emit("sendCard", '发送留资卡-' + row.name + '-' + row.id);
    },

    defriendAction(index) {
      console.log("bottomTools defriendAction index = ", index);

      if (this.isDefriend === false) {
        this.$confirm(
          "你确认要设置拉黑操作吗？",
          "确认要拉黑访客吗？加入黑名单后，系统将收不到该访客的任何信息，直到从黑名单列表中解禁",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            showClose: false,
          }
        )
          .then(() => {
            this.setBlackRequest();
          })
          .catch(() => {});
      } else {
        this.isDefriend = false;
      }
    },

    curTalkAction() {
      this.$emit("curTalkAction");
    },

    interpretAction(index) {
      console.log("bottomTools interpretAction index = ", index);
      this.isTranster = true;
      this.$emit("interpretAction", true);
    },
    showEmoji() {
      const { showEmoji = true } = this.tools || {};
      return showEmoji;
    },
    showkeys() {
      let keys = Object.keys(this.toolConfig);
      const { show = [] } = this.tools || {};
      if (show.length > 0) {
        let _key = [];
        let h = false;
        show.forEach((i) => {
          if (this.isArray(i)) {
            this.newTitle = i;
            return;
          }
          if (i === "history") {
            h = true;
          } else {
            _key.push(i);
          }
        });
        if (h) _key.push("history");
        keys = _key;
      }
      return keys;
    },
    setTitle(key, index) {
      let title = "";
      if (this.newTitle) {
        title = this.newTitle[index] || "";
      }
      if (!title) {
        title = this.toolConfig[key].title;
      }
      return title;
    },
    isArray(target) {
      return Object.prototype.toString.call(target) === "[object Array]";
    },
    selectEmit(type) {
      this.$emit("emoji", type);
      this.$refs.popover.doClose();
    },

    bindButton(type) {
      if ((type === "file") | (type === "img")) {
        // this.$emit('bindBtn', type)
        this.openFile(type);
      } else {
        console.log("tools bindButton type = ", type);
        this.tools.callback(type);
      }
    },

    fileUpload() {
      console.log("tools fileUpload");
      let inputDOM = this.$refs.inputer;
      // 通过DOM取文件数据
      const file = inputDOM.files[0];
      inputDOM.value = "";
      console.log("tools fileUpload file = ", file);
      let size = file.size;
      // console.log("tools fileUpload file.size = ", size,size > 1 * 1024 * 1024);
      if (size > 1 * 1024 * 1024) {
        alert("请选择1M以内的图片！");
        return false;
      }

      this.$emit("upImage", file);
    },

    videoUpload() {
      let inputDOM = this.$refs.inputerVideo;
      // 通过DOM取文件数据
      const file = inputDOM.files[0];
      inputDOM.value = "";
      let size = file.size;
      if (size > 10 * 1024 * 1024) {
        alert("请选择10M以内的视频！");
        return false;
      }

      this.$emit("upVideo", file);
    },

    openFile(type) {
      console.log("tools openFile type = ", type);
      var input = document.createElement("input");
      input.type = "file";
      input.accept = "image/x-png" || "image/jpeg";
      input.multiple = "multiple";
      input.click();
      input.onchange((val) => {
        console.log("openFile onchange val = ", val);
      });
      // input.onchange = function() {
      // 	console.log('tools openFile onchange')
      // 	var file = input.files
      // 	console.log('tools openFile onchange files = ', file)

      // 	let param = new FormData() // 创建form对象
      // 	// let file = e.target.files[0]
      // 	param.append('file', file) // 通过append向form对象添加数据

      // 	console.log('util update file = ', param.get('file')) // FormData私有类对象，访问不到，可以通过get判断值是否传进去
      // 	let config = {
      // 		headers: {
      // 			'Content-Type': 'multipart/form-data'
      // 		}
      // 	}
      // 	let url = ''
      // 	// 添加请求头
      // 	this.axios.post(url, param, config)
      // 		.then(res => {
      // 			console.log('util update1111 res = ', res)
      // 			console.log(res.data)
      // 		})

      // 	// this.uploadImage(file)

      // 	// return file
      // }
    },

    async uploadImage(file) {
      console.log("tools uploadImage file = ", file);
      var api = "/manager/fileInfo/pass/upload";
      const response = await this.util.update({
        url: api,
        method: "POST",
        file: file,
      });
      console.log("tools uploadImage response = ", response);
    },
    //   bindButton (type) {
    //     if (!this.tools.callback) return console.warn('callback not find')
    //     if (type === 'file' | type === 'img') {
    //       this.openFile(type, this.tools.callback)
    //     } else {
    // console.log('tools bindButton type = ', type)
    //       this.tools.callback(type)
    //     }
    //   },
    //   openFile (type, callback) {
    // console.log('tools openFile type = ', type)
    //     var input = document.createElement("input")
    //     input.type = "file"
    //     input.multiple = 'multiple'
    //     input.click();
    //     input.onchange = function () {
    // console.log('tools openFile onchange')
    //       var file = input.files
    // console.log('tools openFile onchange files = ', file)
    //       callback(type, file)
    // this.$emit('sendImage', type)
    // // this.$emit('sendImage', type, file)
    //     }
    //   },
    emojiStyle(item) {
      const emojiitem = this.emoji[item];
      if (!emojiitem) return {};
      return {
        display: "inline-block",
        background: `url('https://res.wx.qq.com/a/wx_fed/webwx/res/static/img/6AfH8-r.png')  no-repeat`,
        width: `28px`,
        height: `28px`,
        "background-position": emojiitem.position,
      };
    },

    // 复制当前浏览url
    copyText() {
      this.getDetailRequest();
    },
  },
  computed: {
    keyName() {
      return this.$store.state.keyName;
    },
  },
  watch: {
    user(newVal, oldVal) {
      console.log("tools.vue watch user new = ", newVal);
      console.log("tools.vue watch user old = ", oldVal);
      this.userInfo = newVal;
      if (this.$store.state.keyName === "疑似骚扰用户") {
        this.isDisturb = true;
      } else {
        this.isDisturb = false;
      }
    },
    keyName(newVal, oldVal) {
      console.log("tools.vue watch keyName new = ", newVal);
      console.log("tools.vue watch keyName old = ", oldVal);
      if (newVal === "疑似骚扰用户") {
        this.isDisturb = true;
      } else {
        this.isDisturb = false;
      }
    },
  },
  mounted() {
    if (this.$store.state.keyName === "疑似骚扰用户") {
      this.isDisturb = true;
    } else {
      this.isDisturb = false;
    }
  },
};
</script>

<style scoped lang="scss">
.toolsBox {
  position: relative;
  background: #f7fbf7;
  // background-color: #E2E8F0;
}
.sendimg {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 60px;
  margin-left: 0.5rem;
  cursor: pointer;
  position: relative;
  &:hover .file_div {
    background-image: url(../../../static/talks/t_sendfilehover.png);
  }
}
.file_input {
  // width: 100%;
  width: 100%;
  height: 100%;
  height: 100%;
  position: absolute;
  cursor: pointer !important;
  background-color: cyan;
  opacity: 0;
  z-index: 10000;
  &::-webkit-file-upload-button {
    cursor: pointer;
  }
}

.file_div {
  background-repeat: no-repeat;
  background-position: center;
  font-size: 0;
  background-image: url(../../../static/talks/t_sendfile.png);
  cursor: pointer;
  z-index: 1000;
  position: relative;
  width: 1.125rem;
  height: 1rem;
  margin-top: 0.125rem;
}

.web__tools {
  text-align: left;
  padding: 0 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 100%;
}

i {
  margin-right: 12px;
  font-size: 20px;
  color: #888a91;
}

i:hover {
  color: #76b1f9;
}

.emjioBox {
  background: #ffffff;
  height: 120px;
  width: 150px;
  overflow: auto;
  text-align: left;
}

.emjioBox .emjio {
  padding: 0;
}

.emjioBox li {
  display: inline-block;
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
}

// .sendBtn {
//   margin-right: 12px;
//   margin-left: 8px;
//   @include change_size($font_size_normal);
// }

.icon_box {
  height: 2.375rem;
  /* background-color: antiquewhite; */
  display: flex;
  justify-content: flex-start;
  margin-left: auto;
}
.btn_div01,
.btn_div02,
.btn_div03,
.btn_div04,
.btn_div,
.end_div,
.btn_div1,
.btn_div2,
.btn_div3,
.btn_div1_select,
.btn_div2_select,
.btn_div3_select {
  height: 38px;
  /* background: grey; */
  margin-left: 8px;
  margin-right: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btn_div {
  width: auto;
  padding-right: 8px;
}

.end_div {
  width: 50px;
}
.btn_div01:hover .btn_title,
.btn_div02:hover .btn_title,
.btn_div03:hover .btn_title,
.btn_div:hover .btn_title,
.end_div:hover .btn_title,
.btn_div1:hover .btn_title,
.btn_div2:hover .btn_title,
.btn_div3:hover .btn_title,
.btn_div4:hover .btn_title {
  color: #1577d2;
}
::v-deep  .el-dialog__header {
  .el-dialog__title::before {
    display: block;
    content: "";
    width: 3px;
    height: auto;
    background-color: #1577d2;
    margin-right: 6px;
  }

  .el-dialog__title {
    display: flex;
    color: #333;
    font-weight: 600;
    line-height: 1;
  }
}
.end_div:hover .btn_icon {
  content: url("../../../static/talks/t_endhover.png");
}
.btn_div01:hover .btn_icon {
  content: url("../../../static/talks/t_smilehover.png");
}
.btn_div02:hover .btn_icon {
  content: url("../../../static/talks/t_interprethover.png");
}

.btn_div03:hover .btn_icon {
  content: url("../../../static/talks/t_alltextcopyhover.png");
}
.btn_div04:hover .btn_icon {
  content: url("../../../static/talks/t_setheightHover.png");
}

.btn_div:hover .btn_icon {
  content: url("../../../static/talks/t_interprethover.png");
}

.btn_div1:hover .btn_icon {
  content: url("../../../static/talks/t_disturbhover.png");
}

.btn_div2:hover .btn_icon {
  content: url("../../../static/talks/t_defriendhover.png");
}

.btn_div3:hover .btn_icon {
  content: url("../../../static/talks/t_adapterhover.png");
}
.btn_title,
.btn_title_select {
  width: 100%;
  height: 15px;
  font-size: 9px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3c8ad3;
  /* background-color: orange; */
  display: flex;
  justify-content: center;
}

.btn_title_select {
  color: red;
}

.btn_icon {
  width: 1.125rem;
  height: 1rem;
  /* margin-bottom: 5px; */
  margin-top: 0.125rem;
}

.disabledClass {
  cursor: not-allowed !important;
}
</style>
